var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-top",
    style: ({
      backgroundColor: _vm.boxBodyColor
    })
  }, [(_vm.displayMode == 2) ? _c('img', {
    attrs: {
      "src": _vm.logoUrl,
      "alt": "公司logo"
    }
  }) : _c('p', {
    staticClass: "companyName"
  }, [(_vm.companyName == '') ? _c('span') : (_vm.companyName.length > 10) ? _c('el-tooltip', {
    attrs: {
      "content": _vm.companyName,
      "placement": "top",
      "effect": "light"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.companyName.substring(0, 10) + '...'))])]) : _c('span', [_vm._v(_vm._s(_vm.companyName))])], 1), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "首页",
      "name": "0"
    }
  }, [_vm._v("首页")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "orderAndService"
  }, [_c('img', {
    staticClass: "order-logo",
    attrs: {
      "src": _vm.imgUrl + 'im_logo.png',
      "alt": "单据logo"
    },
    on: {
      "click": _vm.workOrder
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "order",
    on: {
      "click": _vm.workOrder
    }
  }, [_vm._v("我的单据")]), _vm._v(" "), (_vm.iskf) ? _c('div', {
    staticClass: "im-content",
    on: {
      "click": _vm.intoIm
    }
  }, [_c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/customer-icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "order"
  }, [_vm._v("在线客服")])]) : _vm._e()])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-078819b4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/top.vue
// module id = Xm1c
// module chunks = 1